import React, { Component,Suspense } from "react";
import * as ReactDOM from "react-dom";
import plus from "../image/icons/plus.png"
import edit from "../image/icons/edit.png"
import starImg from "../image/sutlej/star.png"
import Slider from "react-slick";
import $ from 'jquery'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const folderName = window.sessionStorage.getItem("homeName");

export default class Testimonial extends Component {

  constructor(props) {
    super(props);
    this.state = {
      centreData: [],
      sectionName:'Centre',
      parentName:'',
    };
  }

  componentDidMount() {
    const Centre = JSON.parse(window.sessionStorage.getItem("Centre"));
    // console.log(Centre)
    if (Centre) {
      this.setState({ centreData: Centre});
      this.setState({ parentName: Centre[0].parentName })
    } else {
     // window.location.reload(false);
    }
  }

  addClick (sid,pId,cId,psubTitle,cTitile,cSubtitle,cdescri,childUrl,childImg,sOrder) {
    if($("#centreParentId").val()!== "") {
      pId=$("#centreParentId").val();
    }
    if(childImg){
      var splitImg=childImg.split("theme/")
      childImg=splitImg[1];
      }
   
    const LazyPage = React.lazy(() => import("../" + folderName + "/ThemeComponent"));
    ReactDOM.render(
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <section>
            <LazyPage  
              sessionId={sid} 
              parentId={pId}
              childId={cId}
              patentTitle={this.state.parentName}
              parentSubTitle={psubTitle}
              childTitle={cTitile}
              childSubtitle={cSubtitle}
              childDesri={cdescri}
              sectionName={this.state.sectionName}
              childUrl={childUrl}
              childImg={childImg}
              sortSubOrder={sOrder}
            />
          </section>
        </Suspense>
      </div>,
      document.getElementById("centrepopUpBlock")
    );
    $("#centrepopUpBlock").addClass('editActive');
  }

  render() {
    const settings = {
      infinite: false,
      dots: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    };

    return (
      <div class="testimonialsSlider" id="centre">
        <h4 class="mainHead">{this.state.parentName!= '' ? this.state.parentName : 'Testimonials'}</h4>
        {this.props.themeFlag === "theme" && (
        <div className="editIconSec" id="Centre">
           <span className="editIcon editAddIcon" title="Add" onClick={() => this.addClick("14","","","","","","","","","")}><img src={plus} alt="Add"/></span>
           </div>
            )}
           <div className="cmsContentDiv" id="centrepopUpBlock"></div>        
            <input type="hidden" id="centreSectionId" value="14"/>
          {this.state.centreData.map((ban, index) =>{            
          return(
            <div>
          <input type="hidden" id="centreParentId" value={ban.parentId} />
          {ban.sectionList.length !== "0" && (
           <Slider {...settings}>
            {ban.sectionList.map((data, index)=> (
              <div class="testimonials">
                 <div class="testimonials_sub">
                 {this.props.themeFlag === "theme" && (
                      <div className="editIconSec editIconSecTop">
                        <span className="editIcon editAddIcon" title="Edit" 
                        onClick={() => this.addClick
                          (ban.sectionId,
                            ban.parentId,
                            data.childId,
                            ban.parentSubTitle,
                            data.childName,
                            data.childSubtitle,
                            data.childDescription,
                            data.childUrl,
                            data.childImage,
                            data.homeAdsSubSortOrder)}>
                        <img src={edit} alt="logo"/></span>
                    </div>
                 )}
                    <div className="testimonials-list">
                      <div className="testimonials-img">
                        <img src={ data.childImage} width="50"></img>
                      </div>
                    </div>
                      <div class="testimonials-text">
                        <p className="testimonials-text-p">
                          "{data.childDescription}"
                        </p>
                        {data.childName!="@" ? (
                        <h5 className="testimonials-name">{data.childName}</h5>
                        ) : ''}
                      </div>
                 </div>
              </div>
            ))}
        </Slider>
         )}
        </div>
         )})}
      </div>
    );
  }
}
